@if (upload().status_details_parsed.action?.action_type === 'AssignBranchAlias' &&
!upload().status_details_parsed.branch_alias) {
<div>
    <label [for]="'upload_branch_alias_' + upload().id" class="block mb-2 text-sm font-medium text-gray-900">
        Select a branch alias for this upload:
    </label>
    <select (change)="onBranchAliasChange($event)" [name]="'upload_branch_alias_' + upload().id"
        [id]="'upload_branch_alias_' + upload().id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        <option disabled selected value>-- select a branch alias --</option>
        @for (branch_alias of upload().status_details_parsed.action.payload.branch_aliases; track branch_alias) {
        <option [value]="branch_alias">{{ branch_alias }}</option>
        }
    </select>
</div>
}
@if (upload().status_details_parsed.branch_alias) {
<div>Selected branch alias: {{ upload().status_details_parsed.branch_alias }}</div>
}